import Option from "./Option";

const HorizontalOptions = (props) => {

    let list = props.list ? props.list : [];

    return (
        <>
        <div className="d-flex d-row-dir">
            {
                list.map((element,index) => {
                    return <Option callback={props.callback} key={index} data={element} selected={element === props.current} />;
                })
            }
        </div>
        </>
    );
}

export default HorizontalOptions;